import axios from "axios";
import { VERSION } from "../config";
const _MODULE = `/mall/${VERSION}/mobile/order`;
export default {
  /***
   * 支付
   */
  topay(data) {
    return axios({
      url: `${_MODULE}/wechat_h5_pay`,
      method: `POST`,
      data
    });
  },
  /***
   * 支付微信内浏览器
   */
  topayInWeixin(data) {
    return axios({
      url: `${_MODULE}/order/pay`,
      method: `POST`,
      data
    });
  },
  /***
   * 支付微信内浏览器h5
   */
  h5Pay(data) {
    return axios({
      url: `${_MODULE}/h5/pay`,
      method: `POST`,
      data
    });
  },
  /**
   *
   * @param {*} data
   */
  h5AliPay(data) {
    return axios({
      url: `${_MODULE}/ali/h5/pay`,
      method: `POST`,
      data
    });
  }
};



// WEBPACK FOOTER //
// ./src/apis/src/pay.js